import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 180px;
  height: 86px;
  margin-bottom: 5px;
  margin-left: 20px;
  padding: 14px 17px 13px 14px;
  border-radius: 6px;
  backdrop-filter: blur(6px);
  box-shadow:
    0 2px 3px 0 rgba(8, 10, 37, 0.03),
    0 4px 8.5px 0 rgba(8, 10, 37, 0.05),
    0 7.5px 35px 0 rgba(89, 126, 247, 0.03);
  background-color: rgba(16, 25, 56, 0.55);
  color: #ffffff;
  display: none;
`;

export function HoaInfoBox() {
  return (
    <Wrapper className="hoa-infobox-content-wrapper">
      <div className="hoa-infobox-zone-name"></div>
      {/* <div>
        <span>Property:&nbsp;</span>
        <span className="hoa-info-box-property-count" />
      </div>
      <div>
        <span>Listing:&nbsp;</span>
        <span className="hoa-info-box-property-count" />
      </div> */}
    </Wrapper>
  );
}
